import './Header.css'

const Header = () => {
  return (
    <div>
      <div className='about'>
        <div className="about-header">
          <p>ABOUT US</p>
        </div>
      </div>
    </div>
  )
}

export default Header